import { render, staticRenderFns } from "./ProgressTab.vue?vue&type=template&id=67d3f4a7&"
import script from "./ProgressTab.vue?vue&type=script&lang=js&"
export * from "./ProgressTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports